import React, { useEffect } from "react";
import UIBody from "../../../components/ui/UIBody";
import { Link } from "react-router-dom";
import {
  FaChartLine,
  FaPeopleGroup,
  FaGlobe,
  FaMoneyCheckDollar,
  FaArrowsDownToPeople,
  FaCode,
} from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import useApiCallHooks from "../../../hooks/useApiCallHooks";

const ServicesList = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  useEffect(() => {
    callAPI("get", "services");
  }, []);
  return (
    <UIBody
      loading={loading}
      content={
        <div>
          <section
            id="advertisers"
            className="advertisers-service-sec pt-5 pb-5"
          >
            <div className="container">
              <div className="row">
                <div className="section-header text-center">
                  <div className="section__title text-center mb-40">
                    <span className="sub-title">Services</span>
                    <h2 className="title">Explore Our Services</h2>
                    <p className="desc">
                      Technology services for every stage of your journey.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-5 mt-md-4 row-cols-1 row-cols-sm-1 row-cols-md-3 ">
                {responce?.data?.map((service) => (
                  <div className="col" key={service.id}>
                    <div className="service-card">
                      <div className="icon-wrapper">
                        <FaCode /> {/* default icon */}
                      </div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                      <Link to="/add-project-requirements">
                        <button type="button" className="btn">
                          Add Project Details
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
};

export default ServicesList;
